export default "__VITE_ASSET__ByrHXO4B__"